import {Button as ChakraButton} from "@chakra-ui/react"

const Button = ({
                    textTransform,
                    children,
                    margin,
                    maxHeight,
                    padding,
                    bg = "purple.500",
                    width = "133px",
                    gap,
                    maxWidth,
                    height = "40px",
                    border,
                    variant = "solid",
                    fontWeight,
                    borderRadius = "8px",
                    fontSize = "body.lg",
                    fontSizeBase = "body.md",
                    shadowHoverColor = "#6F41D280",
                    textColor = "neutral.100",
                    hoverBg = "purple.200",
                    disabled = false,
                    ...props
                }) => (
    <ChakraButton
        textTransform={textTransform}
        maxHeight={maxHeight}
        maxW={maxWidth}
        margin={margin}
        p={padding}
        gap={gap}
        fontFamily={'IBM Plex Sans'}
        fontWeight={fontWeight}
        zIndex={'10'}
        borderColor={'neutral.800'}
        border={border}
        disabled={disabled}
        bg={disabled ? 'neutral.1000' : bg}
        w={width}
        fontSize={{base: fontSizeBase, lg: fontSize}}
        h={height}
        variant={variant}
        color={textColor}
        borderRadius={borderRadius}
        _hover={{
            boxShadow: !disabled && `0px -4px 20px 1px ${shadowHoverColor} inset`,
            backgroundColor: !disabled && hoverBg
        }}
        {...props}>
        {children}
    </ChakraButton>
);
export default Button;